function FaqItem({ title, answer }) {
  return (
    <div className="single-group">
      <h4 className="text-dark">{title}</h4>
      <div className="faq-answer text-muted" dangerouslySetInnerHTML={{ __html: answer }} />
    </div>
  );
}

export default FaqItem;